module.exports = __webpack_public_path__ + "static/media/lease1_img5.3191ac1c.jpg";